import {
  CanMapPlatformUcrtcBlock,
  CanMapTcuUcrtcBlock,
} from '../models/can-map-block.model';

/** Marker letterali fissi usati per identificare i blocchi generati da questa feature all'interno di data[] */
export const UCMDM_SIGNAL_NAME = 'ucmdm' as const;
export const UCRTC_SIGNAL_NAME = 'ucrtc' as const;

/** Trama RAW fissa del blocco tcu/ucmdm (frame di richiesta parametri) */
export const UCMDM_RAW_TEMPLATE = {
  txID: '0x01D1',
  rxID: '0x01E1',
  extended: false,
};

/** Blocchi statici tcu/platform per ucrtc: aggiunti una sola volta, mai modificati dall'utente */
export const UCRTC_FIXED_BLOCKS: { tcu: CanMapTcuUcrtcBlock; platform: CanMapPlatformUcrtcBlock } = {
  tcu: {
    scope: 'tcu',
    signal_name: UCRTC_SIGNAL_NAME,
    proto: 'RAW',
    on_request: true,
    RAW: { txID: '0x01D4', extended: false },
    period: 250,
  },
  platform: {
    scope: 'platform',
    ref: UCRTC_SIGNAL_NAME,
    signals: [],
  },
};

/**
 * Formula usata per reqPeriod (per-segnale): conversione diretta secondi→ms del valore di `freq`
 * inserito dall'utente nel campo "TELEMATICA - FREQUENZA" (nessuna divisione: reqPeriod è lo
 * stesso periodo richiesto dall'utente, solo espresso in ms per la centralina).
 * Isolato qui per evitare di duplicare la formula nei service.
 */
export function freqToMs(freqSeconds: number): number {
  return freqSeconds * 1000;
}

/**
 * tx_period_ms (valore unico per blocco) è il periodo di trasmissione dell'intero pacchetto,
 * determinato dal segnale più lento (frequenza minima, cioè il valore massimo di freq in secondi).
 * Viene calcolato come: MAX(freq) * 2 * 1000, così il periodo di trasmissione è sufficientemente
 * lungo da contenere tutti i segnali senza perdite.
 * Riceve la frequenza massima (minore valore di freq tra i segnali tele==true) in secondi.
 */
export function computeTxPeriodMs(maxFreqSeconds: number): number {
  return freqToMs(maxFreqSeconds) * 2;
}

/** Default fissi applicati a gain/offset in fase di generazione (modificabili solo manualmente nel popup) */
export const DEFAULT_SIGNAL_GAIN = 1;
export const DEFAULT_SIGNAL_OFFSET = 0;

/** Valori di default per i campi non ancora esposti in UI (dst di default se idCentralina manca) */
export const DEFAULT_DST = 1;

/**
 * Range ammissibili per i campi modificabili manualmente nel popup di salvataggio.
 * Un valore fuori range impedisce il salvataggio su CAN Map (non la sola configurazione).
 */
export const TX_PERIOD_MS_MIN = 1000;
export const TX_PERIOD_MS_MAX = 240000; // MAX(freq) * 2 * 1000 con freq_max=60s → 120000, esteso a 240000 per margine
export const SIGNAL_GAIN_MIN = 0.001;
export const SIGNAL_GAIN_MAX = 1000;
export const SIGNAL_OFFSET_MIN = -10000;
export const SIGNAL_OFFSET_MAX = 10000;
